import {AnalyticsEventHandler} from "../../../../infrastructure/handlers/analytics-event-handler";
import {AnalyticsService} from "../../../../third-party-services/analytics/analytics-service";
import {BETTING_CONTAINER} from "../../betting-container-consts";
import {BettingContainerDrawerMenuNavigationClickEvent} from "../../models/drawer-menu/betting-container.drawer-menu.navigation-click.event";

export class BettingContainerDrawerMenuNavigationClickEventHandler extends AnalyticsEventHandler {
  analyticsService: AnalyticsService;
  type = BETTING_CONTAINER.ACTION_TYPES.DRAWER_MENU.onNavigationClick;

  static injectables = [AnalyticsService];

  constructor(analyticsService: AnalyticsService) {
    super(analyticsService);

    this.eventType = BettingContainerDrawerMenuNavigationClickEvent;
  }
}
